import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { SendCourseCertificate } from "../../../services/sendEmail";

const Courses = () => {
    const dispatch = useDispatch();

    const iframeRef = useRef<HTMLIFrameElement>(null);
    const { name_course } = useParams();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        const handleLoad = async () => {
            try {
                const lastPage = localStorage.getItem("asg_lastpage") || "";
                if (iframe.contentWindow && iframe.contentWindow?.location?.href) {
                    let currentPage = iframe.contentWindow?.location.href || "";
                    currentPage = currentPage.split("?")[0];

                    if (lastPage !== currentPage && currentPage.includes("/courses/final")) {
                        await SendCourseCertificate();
                    }
                    localStorage.setItem("asg_lastpage", currentPage);
                }
            }
            catch (ex) {
                console.error(ex);
            }
        };

        iframe.addEventListener("load", handleLoad);
        return () => {
            iframe.removeEventListener("load", handleLoad);
        };
    }, []);


    return (
        <>
            <iframe
                ref={iframeRef}
                src={`${process.env.PUBLIC_URL}/courses/${name_course}/1/index.html?nocache=${new Date().getTime().toString()}`}
                width="100%"
                height="100%"
                title="SCTR"
                style={{ border: "none" }}
            />
        </>
    )
}

export default Courses;